import * as React from 'react'
import { StoreProps } from '../../../../services/stores/casting.store'
import { offeredServiceFlattenedTaskItemTaskTree, offeredServiceIsItemTask } from '../../../../services/models/offered-services.service'

export default function CastingTasksPickerComponent ({ store, data: { offeredService: { tasks, item_tasks }, selectedTaskItemIds } }: StoreProps) {
  return <>
    { offeredServiceFlattenedTaskItemTaskTree(tasks, item_tasks).map(taskOrItemTask => <div
      key={ `${offeredServiceIsItemTask(taskOrItemTask) ? 'item-task' : 'task'}-${taskOrItemTask.id}` }
      className={ offeredServiceIsItemTask(taskOrItemTask) ? 'inputCheckbox' : '' }
      style={ (!offeredServiceIsItemTask(taskOrItemTask) || !taskOrItemTask.task_id) ? { margin: '0.5em' } : { marginLeft: '1.5em' } } 
    >
        { !offeredServiceIsItemTask(taskOrItemTask) && <strong>{ taskOrItemTask.name }</strong> }
        { offeredServiceIsItemTask(taskOrItemTask) && <>
          <input
            type="checkbox"
            id={ `item-task-${taskOrItemTask.id}` }
            onChange={ evt => store.set({ selectedTaskItemIds: selectedTaskItemIds.filter(_ => _ !== taskOrItemTask.id).concat(evt.target.checked ? [taskOrItemTask.id] : []) }) }
            checked={ selectedTaskItemIds.includes(taskOrItemTask.id) } 
          />
          <label htmlFor={ `item-task-${taskOrItemTask.id}` }>{ taskOrItemTask.name }</label>
        </> }
    </div>) }
  </>
}
